var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddAmt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2915 7.81238C16.2915 8.06102 16.1927 8.29947 16.0169 8.47529C15.8411 8.65111 15.6026 8.74988 15.354 8.74988H9.4165V14.6874C9.4165 14.936 9.31773 15.1745 9.14192 15.3503C8.9661 15.5261 8.72764 15.6249 8.479 15.6249C8.23036 15.6249 7.99191 15.5261 7.81609 15.3503C7.64028 15.1745 7.5415 14.936 7.5415 14.6874V8.74988H1.604C1.35536 8.74988 1.11691 8.65111 0.941091 8.47529C0.765276 8.29947 0.666504 8.06102 0.666504 7.81238C0.666504 7.56374 0.765276 7.32528 0.941091 7.14947C1.11691 6.97365 1.35536 6.87488 1.604 6.87488H7.5415V0.937378C7.5415 0.688737 7.64028 0.450281 7.81609 0.274465C7.99191 0.09865 8.23036 -0.00012207 8.479 -0.00012207C8.72764 -0.00012207 8.9661 0.09865 9.14192 0.274465C9.31773 0.450281 9.4165 0.688737 9.4165 0.937378V6.87488H15.354C15.6026 6.87488 15.8411 6.97365 16.0169 7.14947C16.1927 7.32528 16.2915 7.56374 16.2915 7.81238Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddAmt);
export default __webpack_public_path__ + "static/media/addAmt.24c825eaa68fb4ac53bff54278f07b67.svg";
export { ForwardRef as ReactComponent };